import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import ChecklistFilter from '../EidFilter/GenericFilter/ChecklistFilter'

const ParticipantTypeFilter = () => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()

    const filter = (
        <ChecklistFilter
            transformResponse={(data) =>
                data.map((i) => ({
                    id: i.name,
                    name: i.name,
                    friendlyName: t(`${i.name}`),
                }))
            }
            url="api/Lookup/participantTypes"
            value={state.participantType}
            onChange={(payload) => {
                dispatch({
                    type: 'SET_PROP',
                    payload: {
                        key: 'participantType',
                        value: payload,
                    },
                })
            }}
        />
    )

    return (
        <Card
            cardTitle={t('ParticipantType')}
            collapsible
            expanded={state.participantType && state.participantType.length > 0}
        >
            {filter}
        </Card>
    )
}

export default ParticipantTypeFilter
